var product = {

    isScrolling:false,

    currentTabIndex:1,

    navSwiper : null,

    initNavSwiper: function(index){
        var self =this;
      this.navSwiper = new Swiper('.swiper-container-navigation' ,{
          slidesPerView: 'auto',
          freeMode: true,
      })
    },

    bannerSwipers: [],

    initSwiper: function(index){

        // console.log($('#product-'+index+'-banner-count').val());

        var bannerAutoPlay = false;
        if (parseInt($('#product-' + index + '-banner-count').val()) > 1) {
            bannerAutoPlay = {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            };
        }

        var bannerswiper = new Swiper ('.swiper-container-product-banner-'+index, {
            centeredSlides: true,
            loop: parseInt($('#product-'+index+'-banner-count').val()) >1, // 循环模式选项
            observer:true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,//修改swiper的父元素时，自动初始化swiper
            autoplay: bannerAutoPlay,
            disableOnInteraction: false,
            // 如果需要分页器
            pagination: {
                el: '.swiper-pagination-product-banner-'+index,
            },
        });
        this.bannerSwipers.push(bannerswiper);

        new Swiper('.swiper-container-product-'+index,{
            slidesPerView : 2,
            slidesPerGroup: 2,
            // spaceBetween: 20,
            pagination: {
                el: '.swiper-pagination-product-'+index,
            },
        })
    },


    scrollEvent: function(){
        var self = this;
        $(window).scroll(function () {

            if (!self.isScrolling) {
                var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

                self.offsetTopNavs = [];
                for (var i = 0; i < 9; i++) {
                    var id =  "#product-group-" + i;
                    self.offsetTopNavs.push(document.querySelector(id) ? document.querySelector(id).offsetTop : 99999);
                }

                scrollTop = scrollTop + 100;
                var swiperLoopOffsetTop = scrollTop + window.screen.height/2; //轮播图到屏幕一半时开始轮播
                for (var i = 0; i < self.offsetTopNavs.length; i++) {
                    //加一个tab高度，否则挡住标题才能会触发tab切换
                    if (i < self.offsetTopNavs.length - 1 && scrollTop >= self.offsetTopNavs[i] && scrollTop < self.offsetTopNavs[i+1] && self.currentTabIndex != i){
                        self.showList(i);
                        break;
                    }else if (scrollTop >= self.offsetTopNavs[self.offsetTopNavs.length - 1] && self.currentTabIndex != self.offsetTopNavs.length - 1) {
                        self.showList(self.offsetTopNavs.length - 1);
                        break;
                    }

                    if (i < self.offsetTopNavs.length - 1 && swiperLoopOffsetTop >= self.offsetTopNavs[i] && swiperLoopOffsetTop < self.offsetTopNavs[i+1] && self.currentTabIndex != i){
                        self.updateSwiper(i);
                        break;
                    }else if (swiperLoopOffsetTop >= self.offsetTopNavs[self.offsetTopNavs.length - 1] && self.currentTabIndex != self.offsetTopNavs.length - 1) {
                        self.updateSwiper(self.offsetTopNavs.length - 1);
                        break;
                    }
                }
            }

        });
    },

    //点击tab 跳转锚点
    //istabEvent 是否是tab事件触发
    showList: function(index,istabEvent){
        var self = this;
        this.currentTabIndex = index;

        //选中效果
        $(".swiper-container-navigation .swiper-wrapper .swiper-slide").removeClass('swiper-slide-act');
        $(".swiper-container-navigation").find('.swiper-slide').eq(index).addClass('swiper-slide-act');

        // navigation 滑动效果
        if (index > 1 && index < 8) {
            this.navSwiper.setTransition(500);
            this.navSwiper.setTranslate( - (window.screen.width / 5 + (index - 2) * window.screen.width / 4 ) , 1000)
        } else if(index <= 1){
            this.navSwiper.setTransition(500);
            this.navSwiper.setTranslate(0);
        }


        if (istabEvent){
            //点击tab事件才触发
            self.isScrolling = true;
            self.updateSwiper(index);

            if (index == 0){
                $('html, body').animate({scrollTop: 0}, 1000,'',function () {
                    self.isScrolling = false;
                });
                return false;
            }

            $('html, body').animate({scrollTop: document.getElementById("product-group-"+index).offsetTop - 100}, 1000, '', function () {
                self.isScrolling = false;
            })

        }

    },

    //更新swiper轮播
    updateSwiper: function(index){
        this.bannerSwipers.forEach(function (item, i) {
            if (item.autoplay) {
                if (index == i && parseInt($('#product-'+index+'-banner-count').val()) > 1 ){
                    item.autoplay.start();
                } else{
                    item.autoplay.stop();
                }
            }
        })
    },

    init: function () {
        for (var i = 0; i < 9; i++) {
            this.initSwiper(i)
        }
        var firstModule = this.bannerSwipers[0];
        firstModule.autoplay.start();
        this.initNavSwiper();
        this.scrollEvent();
        var self = this;
        window.onload = function () {
            self.isScrolling = true;
            $('html, body').animate({scrollTop: 0}, 100, '', function () {
                self.isScrolling = false;
            })
            self.showList(0)
        }
    }
}
